// src/components/Minihome/WidgetRegistry.js

import AboutCard from "./widgets/AboutCard";
import Guestbook from "./widgets/Guestbook";
import TitleShowcaseWidget from "./widgets/TitleShowcaseWidget";
import EmoteShelf from "./widgets/EmoteShelf";
import ReactionBar from "./widgets/ReactionBar";
// ✅ 1. 새로 만든 텍스트 박스 위젯을 import 합니다.
import TextBoxWidget from "./widgets/TextBoxWidget";
// ✅ 2. 텍스트 박스 위젯용 CSS도 import 합니다.
import "./widgets/TextBoxWidget.css";


const WidgetRegistry = {
    about: AboutCard,
    guestbook: Guestbook,
    titleShowcase: TitleShowcaseWidget,
    emoteShelf: EmoteShelf,
    reactionBar: ReactionBar,
    // ✅ 3. 'textBox'라는 키로 새 위젯을 등록합니다.
    textBox: TextBoxWidget,
};

export default WidgetRegistry;